





















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import ApprovalDraw from './dialog/approval.vue';
import Launch from './dialog/launch.vue';
import BranchCondition from './dialog/branchCondition.vue';
import TransactorDrawer from './dialog/transactorDrawer.vue';
import CopyList from './dialog/copyList.vue';
import { uuid } from '@/util/uuid';
@Component({
  components: { ApprovalDraw, Launch, BranchCondition, TransactorDrawer, CopyList },
})
export default class NodeWrap extends Vue {
  @Prop() nodeConfig: any;
  @Prop() flowPermission: any;
  @Prop() directorMaxLevel: any;
  @Prop() isTried: any;
  @Prop() tableId: any;
  @Prop() allForm: any;
  // @Props: ['nodeConfig', 'flowPermission', 'directorMaxLevel', 'isTried', 'tableId'],

  placeholderList: any = ['发起人', '审核人', '抄送人', '办理人'];
  isInputList: any = [];
  isInput: any = false;
  // promoterVisible: any = false;
  promoterDrawer: any = false;
  // departments: any = {};
  // checkedDepartmentList: any = [];
  // checkedEmployessList: any = [];
  // promoterSearchName: any = '';
  flowPermission1: any = this.flowPermission;
  approverDrawer: any = false;
  // approverVisible: any = false;
  // approverRoleVisible: any = false;
  approverConfig: any = {};
  // approverEmplyessList: any = [];
  // approverSearchName: any = '';
  // roles: any = [];
  roleList: any = [];
  // approverRoleSearchName: any = '';
  copyerDrawer: any = false;
  // copyerVisible: any = false;
  copyerConfig: any = {};
  // copyerSearchName: any = '';
  // activeName: any = '1';
  // copyerEmployessList: any = [];
  // copyerRoleList: any = [];
  ccSelfSelectFlag: any = [];
  conditionDrawer: any = false;
  // conditionVisible: any = false;
  conditionConfig: any = {};
  conditionsConfig: any = {
    conditionNodes: [],
  };
  bPriorityLevel: any = '';
  // conditions: any = [];
  conditionList: any = [];
  // conditionRoleVisible: any = false;
  // conditionRoleSearchName: any = '';
  // conditionDepartmentList: any = [];
  // conditionEmployessList: any = [];
  // conditionRoleList: any = [];
  mounted() {
    if (this.nodeConfig.type === 1) {
      this.nodeConfig.error = !this.setApproverStr(this.nodeConfig);
    } else if (this.nodeConfig.type === 2) {
      this.nodeConfig.error = !this.copyerStr(this.nodeConfig);
    } else if (this.nodeConfig.type === 3) {
      this.nodeConfig.error = !this.setApproverStr(this.nodeConfig);
    } else if (this.nodeConfig.type === 4) {
      for (let i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error = this.conditionStr(this.nodeConfig.conditionNodes[i], i) === '请设置条件' && i !== this.nodeConfig.conditionNodes.length - 1;
      }
    }
  }
  clickEvent(index: any) {
    if (index || index === 0) {
      this.$set(this.isInputList, index, true);
    } else {
      this.isInput = true;
    }
  }
  blurEvent(index: any) {
    if (index || index === 0) {
      this.$set(this.isInputList, index, false);
      this.nodeConfig.conditionNodes[index].nodeName = this.nodeConfig.conditionNodes[index].nodeName ? this.nodeConfig.conditionNodes[index].nodeName : '条件';
    } else {
      this.isInput = false;
      this.nodeConfig.nodeName = this.nodeConfig.nodeName ? this.nodeConfig.nodeName : this.placeholderList[this.nodeConfig.type];
    }
  }
  conditionStr(item: any, index: any) {
    console.log('-----conditionStr-----');
    console.log(item);
    const arr: any = [];
    if (item.conditionGroups.length > 0) {
      item.conditionGroups.forEach((group: any) => {
        const arrItem: any = [];
        if (group.conditions.length > 0) {
          group.conditions.forEach((item: any) => {
            if (item.property.label) {
              arrItem.push(item.property.label);
            }
            if (item.property.dept) {
            }
            if (item.property.staff) {
            }
          });
          const label: any = arrItem.join(' *并且* ');
          arr.push('( ' + label + ' )');
        } else {
          arr.push('( 空条件组 )');
        }
      });
      const label: any = arr.join(' *或者* ');
      return label;
    } else {
      return '请设置条件';
    }

    // item.conditionGroups[index].conditions.forEach((item: any) => {
    //   arr.push(item.property.label);
    // });
    // return arr.join('&&');
    // return '请设置条件';
    // const { conditionList, nodeUserList } = item;
    // if (conditionList.length === 0) {
    //   return index === this.nodeConfig.conditionNodes.length - 1 && this.nodeConfig.conditionNodes[0].conditionList.length !== 0 ? '其他条件进入此流程' : '请设置条件';
    // } else {
    //   let str = '';
    //   for (let i = 0; i < conditionList.length; i++) {
    //     const { columnId, columnType, showType, showName, optType, zdy1, opt1, zdy2, opt2, fixedDownBoxValue } = conditionList[i];
    //     if (columnId === 0) {
    //       if (nodeUserList.length !== 0) {
    //         str += '发起人属于：';
    //         str +=
    //           nodeUserList
    //             .map((item: any) => {
    //               return item.name;
    //             })
    //             .join('或') + ' 并且 ';
    //       }
    //     }
    //     if (columnType === 'String' && showType === '3') {
    //       if (zdy1) {
    //         str += showName + '属于：' + this.dealStr(zdy1, JSON.parse(fixedDownBoxValue)) + ' 并且 ';
    //       }
    //     }
    //     if (columnType === 'Double') {
    //       if (optType !== 6 && zdy1) {
    //         const optTypeStr = ['', '<', '>', '≤', '=', '≥'][optType];
    //         str += `${showName} ${optTypeStr} ${zdy1} 并且 `;
    //       } else if (optType === 6 && zdy1 && zdy2) {
    //         str += `${zdy1} ${opt1} ${showName} ${opt2} ${zdy2} 并且 `;
    //       }
    //     }
    //   }
    //   return str ? str.substring(0, str.length - 4) : '请设置条件';
    // }
  }
  dealStr(str: any, obj: any) {
    const arr: any = [];
    const list = str.split(',');
    for (const elem in obj) {
      list.map((item: any) => {
        if (item === elem) {
          arr.push(obj[elem].value);
        }
      });
    }
    return arr.join('或');
  }
  copyerStr(nodeConfig: any) {
    if (!nodeConfig.assign) {
      return;
    }
    if (nodeConfig.assign.assignWay === 'staff') {
      return nodeConfig.assign.label;
    }

    if (nodeConfig.assign.assignWay === 'sponsorChoose') {
      return '发起人自选';
    }

    if (nodeConfig.assign.assignWay === 'dept') {
      return nodeConfig.assign.label;
    }

    if (nodeConfig.assign.assignWay === 'sponsor') {
      return '发起人自己';
    }

    if (nodeConfig.assign.assignWay === 'contactPerson') {
      return '<' + nodeConfig.assign.label + '> 表单内联系人';
    }

    if (nodeConfig.assign.assignWay === 'deptPrincipal') {
      return '部门负责人';
    }

    if (nodeConfig.assign.assignWay === 'superDept') {
      return '上级部门';
    }
  }
  setApproverStr(nodeConfig: any) {
    // console.log('------nodeConfig------');
    // console.log(nodeConfig);
    if (!nodeConfig.assign) {
      return;
    }
    if (nodeConfig.assign.assignWay === 'staff') {
      return nodeConfig.assign.label;
    }

    if (nodeConfig.assign.assignWay === 'sponsorChoose') {
      return '发起人自选';
    }

    if (nodeConfig.assign.assignWay === 'dept') {
      return nodeConfig.assign.label;
    }

    if (nodeConfig.assign.assignWay === 'sponsor') {
      return '发起人自己';
    }

    if (nodeConfig.assign.assignWay === 'contactPerson') {
      return '<' + nodeConfig.assign.label + '> 表单内联系人';
    }

    if (nodeConfig.assign.assignWay === 'deptPrincipal') {
      return '部门负责人';
    }

    if (nodeConfig.assign.assignWay === 'superDept') {
      return '上级部门';
    }

    // if (nodeConfig.settype === 1) {
    //   if (nodeConfig.nodeUserList.length === 1) {
    //     return nodeConfig.nodeUserList[0].name;
    //   } else if (nodeConfig.nodeUserList.length > 1) {
    //     if (nodeConfig.examineMode === 1) {
    //       return this.arrToStr(nodeConfig.nodeUserList);
    //     } else if (nodeConfig.examineMode === 2) {
    //       return nodeConfig.nodeUserList.length + '人会签';
    //     }
    //   }
    // } else if (nodeConfig.settype === 4) {
    //   if (nodeConfig.selectRange === 1) {
    //     return '发起人自选';
    //   } else {
    //     if (nodeConfig.nodeUserList.length > 0) {
    //       if (nodeConfig.selectRange === 2) {
    //         return '发起人自选';
    //       } else {
    //         return '发起人从' + nodeConfig.nodeUserList[0].name + '中自选';
    //       }
    //     } else {
    //       return '';
    //     }
    //   }
    // } else if (nodeConfig.settype === 5) {
    //   return '发起人自己';
    // }
  }
  arrToStr(arr: any) {
    if (arr) {
      return arr
        .map((item: any) => {
          return item.name;
        })
        .toString();
    }
  }
  delNode() {
    console.log(this.nodeConfig);
    this.$emit('update:nodeConfig', this.nodeConfig.childNode);
  }
  addTerm() {
    const len = this.nodeConfig.conditionNodes.length + 1;
    this.nodeConfig.conditionNodes.push({
      nodeName: '条件' + len,
      type: 5,
      id: uuid(),
      priorityLevel: len,
      conditionList: [],
      nodeUserList: [],
      conditionGroups: [],
      childNode: null,
    });
    for (let i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
      this.nodeConfig.conditionNodes[i].error = this.conditionStr(this.nodeConfig.conditionNodes[i], i) === '请设置条件' && i !== this.nodeConfig.conditionNodes.length - 1;
    }
    this.$emit('update:nodeConfig', this.nodeConfig);
  }
  delTerm(index: any) {
    this.nodeConfig.conditionNodes.splice(index, 1);
    for (let i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
      this.nodeConfig.conditionNodes[i].error = this.conditionStr(this.nodeConfig.conditionNodes[i], i) === '请设置条件' && i !== this.nodeConfig.conditionNodes.length - 1;
    }
    this.$emit('update:nodeConfig', this.nodeConfig);
    if (this.nodeConfig.conditionNodes.length === 1) {
      if (this.nodeConfig.childNode) {
        if (this.nodeConfig.conditionNodes[0].childNode) {
          this.reData(this.nodeConfig.conditionNodes[0].childNode, this.nodeConfig.childNode);
        } else {
          this.nodeConfig.conditionNodes[0].childNode = this.nodeConfig.childNode;
        }
      }
      this.$emit('update:nodeConfig', this.nodeConfig.conditionNodes[0].childNode);
    }
  }
  reData(data: any, addData: any) {
    if (!data.childNode) {
      data.childNode = addData;
    } else {
      this.reData(data.childNode, addData);
    }
  }
  setData(data: any) {
    // console.log(data);
    // this.nodeConfig = data;
    Vue.set(this, 'nodeConfig', data);
    this.$emit('update:nodeConfig', this.nodeConfig);
  }

  setPerson(priorityLevel: any) {
    console.log(this.nodeConfig);
    const { type } = this.nodeConfig;
    if (type === 0) {
      // 发起人
      // this.promoterDrawer = true;
      // this.flowPermission1 = this.flowPermission;
      const ref: any = this.$refs.launch;
      ref.showDrawer(this.allForm.form, this.nodeConfig);
    } else if (type === 1) {
      // 审核人
      const ref: any = this.$refs.approval;
      console.log(this.allForm);
      ref.showDrawer(this.nodeConfig, this.allForm.form, this.allForm);
      // this.approverDrawer = true;
      // this.approverConfig = JSON.parse(JSON.stringify(this.nodeConfig));
      // this.approverConfig.settype = this.approverConfig.settype ? this.approverConfig.settype : 1;
    } else if (type === 2) {
      // 抄送人
      const ref: any = this.$refs.copyList;
      console.log(this.allForm);
      ref.showDrawer(this.nodeConfig, this.allForm.form);

      // this.copyerDrawer = true;
      // this.copyerConfig = JSON.parse(JSON.stringify(this.nodeConfig));
      // this.ccSelfSelectFlag = this.copyerConfig.ccSelfSelectFlag === 0 ? [] : [this.copyerConfig.ccSelfSelectFlag];
    } else if (type === 3) {
      // 办理人
      const transactorDrawer = 'transactorDrawer';
      const transactorDrawerComponent = this.$refs[transactorDrawer];
      (transactorDrawerComponent as any).showDrawer(this.nodeConfig, this.allForm.form);
    } else {
      // 条件分支
      const branchCondition = 'branchCondition';
      const branchConditionComponent = this.$refs[branchCondition];
      (branchConditionComponent as any).showDrawer(this.nodeConfig, this.allForm.form, priorityLevel);
      // this.conditionDrawer = true;
      // this.bPriorityLevel = priorityLevel;
      this.conditionsConfig = JSON.parse(JSON.stringify(this.nodeConfig));
      this.conditionConfig = this.conditionsConfig.conditionNodes[priorityLevel - 1];
    }
  }
  arrTransfer(index: any, type: any = 1) {
    //向左-1,向右1
    this.nodeConfig.conditionNodes[index] = this.nodeConfig.conditionNodes.splice(index + type, 1, this.nodeConfig.conditionNodes[index])[0];
    this.nodeConfig.conditionNodes.map((item: any, index: any) => {
      item.priorityLevel = index + 1;
    });
    for (let i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
      this.nodeConfig.conditionNodes[i].error = this.conditionStr(this.nodeConfig.conditionNodes[i], i) === '请设置条件' && i !== this.nodeConfig.conditionNodes.length - 1;
    }
    this.$emit('update:nodeConfig', this.nodeConfig);
  }
}
